// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/review_requests.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Reviewer } from "./reviewer_pb";
import { file_pull_requests_v1_reviewer } from "./reviewer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/review_requests.proto.
 */
export const file_pull_requests_v1_review_requests: GenFile = /*@__PURE__*/
  fileDesc("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", [file_pull_requests_v1_reviewer]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/review_requests
 *
 * Defined by PullRequests::PageData::SharedController#review_requests.
 *
 * @generated from message github.pull_requests.v1.ReviewRequestsResponse
 */
export type ReviewRequestsResponse = Message<"github.pull_requests.v1.ReviewRequestsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.PendingReviewRequest pending_review_requests = 1;
   */
  pendingReviewRequests: PendingReviewRequest[];

  /**
   * @generated from field: repeated github.pull_requests.v1.CompletedReview completed_reviews = 2;
   */
  completedReviews: CompletedReview[];

  /**
   * @generated from field: github.pull_requests.v1.Reviewer copilot_reviewer = 3;
   */
  copilotReviewer?: Reviewer;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewerRow copilot_reviewer_row = 4;
   */
  copilotReviewerRow?: CopilotReviewerRow;
};

/**
 * Describes the message github.pull_requests.v1.ReviewRequestsResponse.
 * Use `create(ReviewRequestsResponseSchema)` to create a new message.
 */
export const ReviewRequestsResponseSchema: GenMessage<ReviewRequestsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 0);

/**
 * @generated from message github.pull_requests.v1.CopilotReviewEffortOption
 */
export type CopilotReviewEffortOption = Message<"github.pull_requests.v1.CopilotReviewEffortOption"> & {
  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort value = 1;
   */
  value: CopilotReviewEffort;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffortAvailability availability = 4;
   */
  availability: CopilotReviewEffortAvailability;
};

/**
 * Describes the message github.pull_requests.v1.CopilotReviewEffortOption.
 * Use `create(CopilotReviewEffortOptionSchema)` to create a new message.
 */
export const CopilotReviewEffortOptionSchema: GenMessage<CopilotReviewEffortOption> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 1);

/**
 * @generated from message github.pull_requests.v1.CopilotReviewerRow
 */
export type CopilotReviewerRow = Message<"github.pull_requests.v1.CopilotReviewerRow"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: bool requestable = 2;
   */
  requestable: boolean;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort selected_review_effort = 3;
   */
  selectedReviewEffort: CopilotReviewEffort;

  /**
   * @generated from field: repeated github.pull_requests.v1.CopilotReviewEffortOption review_effort_options = 4;
   */
  reviewEffortOptions: CopilotReviewEffortOption[];

  /**
   * @generated from field: string learn_more_url = 5;
   */
  learnMoreUrl: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort last_executed_review_effort = 6;
   */
  lastExecutedReviewEffort: CopilotReviewEffort;

  /**
   * @generated from field: string selected_review_effort_source = 7;
   */
  selectedReviewEffortSource: string;

  /**
   * @generated from field: bool review_effort_level_selected = 8;
   */
  reviewEffortLevelSelected: boolean;

  /**
   * True when last_executed_review_effort ran because the review requested Auto.
   *
   * @generated from field: bool last_executed_review_effort_auto = 9;
   */
  lastExecutedReviewEffortAuto: boolean;

  /**
   * @generated from field: repeated github.pull_requests.v1.CopilotReviewEffortDefaultSettingLink default_setting_links = 10;
   */
  defaultSettingLinks: CopilotReviewEffortDefaultSettingLink[];
};

/**
 * Describes the message github.pull_requests.v1.CopilotReviewerRow.
 * Use `create(CopilotReviewerRowSchema)` to create a new message.
 */
export const CopilotReviewerRowSchema: GenMessage<CopilotReviewerRow> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 2);

/**
 * @generated from message github.pull_requests.v1.CopilotReviewEffortDefaultSettingLink
 */
export type CopilotReviewEffortDefaultSettingLink = Message<"github.pull_requests.v1.CopilotReviewEffortDefaultSettingLink"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string href = 2;
   */
  href: string;
};

/**
 * Describes the message github.pull_requests.v1.CopilotReviewEffortDefaultSettingLink.
 * Use `create(CopilotReviewEffortDefaultSettingLinkSchema)` to create a new message.
 */
export const CopilotReviewEffortDefaultSettingLinkSchema: GenMessage<CopilotReviewEffortDefaultSettingLink> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 3);

/**
 * @generated from message github.pull_requests.v1.PendingReviewRequest
 */
export type PendingReviewRequest = Message<"github.pull_requests.v1.PendingReviewRequest"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: bool is_code_owner = 2;
   */
  isCodeOwner: boolean;

  /**
   * @generated from field: bool is_code_owner_from_delegation = 3;
   */
  isCodeOwnerFromDelegation: boolean;

  /**
   * Deferred reason; UNSPECIFIED (omitted) for an active request.
   *
   * @generated from field: github.pull_requests.v1.DeferredType deferred_type = 4;
   */
  deferredType: DeferredType;

  /**
   * Delegating team; absent when the request was not delegated (legacy null).
   *
   * @generated from field: github.pull_requests.v1.Reviewer delegated_from_team = 5;
   */
  delegatedFromTeam?: Reviewer;

  /**
   * ISO 8601 timestamp; absent for deferred requests (legacy null).
   *
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort requested_copilot_review_effort = 7;
   */
  requestedCopilotReviewEffort: CopilotReviewEffort;
};

/**
 * Describes the message github.pull_requests.v1.PendingReviewRequest.
 * Use `create(PendingReviewRequestSchema)` to create a new message.
 */
export const PendingReviewRequestSchema: GenMessage<PendingReviewRequest> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 4);

/**
 * @generated from message github.pull_requests.v1.CompletedReview
 */
export type CompletedReview = Message<"github.pull_requests.v1.CompletedReview"> & {
  /**
   * Review id. int64 (serialized as a JSON string) since ids can exceed the
   * int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 2;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: github.pull_requests.v1.ReviewState state = 3;
   */
  state: ReviewState;

  /**
   * @generated from field: string head_sha = 4;
   */
  headSha: string;

  /**
   * ISO 8601 timestamp.
   *
   * @generated from field: string submitted_at = 5;
   */
  submittedAt: string;

  /**
   * @generated from field: bool has_write_access = 6;
   */
  hasWriteAccess: boolean;

  /**
   * @generated from field: bool can_re_request = 7;
   */
  canReRequest: boolean;

  /**
   * @generated from field: repeated github.pull_requests.v1.Reviewer on_behalf_of_teams = 8;
   */
  onBehalfOfTeams: Reviewer[];

  /**
   * State immediately before dismissal; UNSPECIFIED for reviews that have not
   * been dismissed or whose prior state is unavailable.
   *
   * @generated from field: github.pull_requests.v1.ReviewState dismissed_review_state = 9;
   */
  dismissedReviewState: ReviewState;
};

/**
 * Describes the message github.pull_requests.v1.CompletedReview.
 * Use `create(CompletedReviewSchema)` to create a new message.
 */
export const CompletedReviewSchema: GenMessage<CompletedReview> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 5);

/**
 * Why a pending review request is deferred. UNSPECIFIED is an active
 * (non-deferred) request, which the legacy JSON encodes as null.
 *
 * @generated from enum github.pull_requests.v1.DeferredType
 */
export enum DeferredType {
  /**
   * @generated from enum value: DEFERRED_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEFERRED_TYPE_CODEOWNER = 1;
   */
  CODEOWNER = 1,

  /**
   * @generated from enum value: DEFERRED_TYPE_COPILOT = 2;
   */
  COPILOT = 2,
}

/**
 * Describes the enum github.pull_requests.v1.DeferredType.
 */
export const DeferredTypeSchema: GenEnum<DeferredType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 0);

/**
 * State of a completed review. The legacy JSON encodes this as a lowercase
 * string ("approved", "commented", "changes_requested", "dismissed",
 * "pending").
 *
 * @generated from enum github.pull_requests.v1.ReviewState
 */
export enum ReviewState {
  /**
   * @generated from enum value: REVIEW_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REVIEW_STATE_COMMENTED = 2;
   */
  COMMENTED = 2,

  /**
   * @generated from enum value: REVIEW_STATE_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: REVIEW_STATE_CHANGES_REQUESTED = 4;
   */
  CHANGES_REQUESTED = 4,

  /**
   * @generated from enum value: REVIEW_STATE_DISMISSED = 5;
   */
  DISMISSED = 5,
}

/**
 * Describes the enum github.pull_requests.v1.ReviewState.
 */
export const ReviewStateSchema: GenEnum<ReviewState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 1);

/**
 * @generated from enum github.pull_requests.v1.CopilotReviewEffort
 */
export enum CopilotReviewEffort {
  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_HIGH = 3;
   */
  HIGH = 3,

  /**
   * The effort router picks low, medium, or high per review. Never an executed effort.
   *
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AUTO = 4;
   */
  AUTO = 4,
}

/**
 * Describes the enum github.pull_requests.v1.CopilotReviewEffort.
 */
export const CopilotReviewEffortSchema: GenEnum<CopilotReviewEffort> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 2);

/**
 * @generated from enum github.pull_requests.v1.CopilotReviewEffortAvailability
 */
export enum CopilotReviewEffortAvailability {
  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_COMING_SOON = 2;
   */
  COMING_SOON = 2,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_PREVIEW_REQUIRED = 3;
   */
  PREVIEW_REQUIRED = 3,
}

/**
 * Describes the enum github.pull_requests.v1.CopilotReviewEffortAvailability.
 */
export const CopilotReviewEffortAvailabilitySchema: GenEnum<CopilotReviewEffortAvailability> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 3);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ReviewRequestsResponseSchema, "6c32fba4ce9d")
registerSchemaHash(CopilotReviewEffortOptionSchema, "6a77259bd4d7")
registerSchemaHash(CopilotReviewerRowSchema, "0dd989b00c0e")
registerSchemaHash(CopilotReviewEffortDefaultSettingLinkSchema, "a58a1c319938")
registerSchemaHash(PendingReviewRequestSchema, "7c2f2bb9063b")
registerSchemaHash(CompletedReviewSchema, "9a1a98988744")
